import { Box } from '@mui/material';
import {
  RAIL_COLUMN_GAP,
  RAIL_NODE_WIDTH,
} from '../../../../constants/customers';

interface Props {
  onClick: () => void;
  isLoading: boolean;
}

function LoadEarlierActivityLink({ onClick, isLoading }: Props) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      disabled={isLoading}
      sx={{
        display: 'block',
        background: 'none',
        border: 'none',
        padding: 0,
        marginTop: '24px',
        paddingLeft: `${RAIL_NODE_WIDTH + RAIL_COLUMN_GAP}px`,
        color: 'primary.main',
        cursor: 'pointer',
        typography: 'h5',
        fontWeight: 700,
      }}>
      {isLoading ? 'Loading…' : 'Load earlier activity'}
    </Box>
  );
}

export default LoadEarlierActivityLink;
